import React, { useState } from 'react';
import StateProcess from '../stateProcess';
import StateMasiveOne from '../stateMasiveOne';
import StateMasiveThree from '../stateMasiveThree';
import DocumentProcess from '../documentProcess';
import StateMasiveStatusPay from '../stateMasiveStatusPay';
import { Dashboard, PodContainer, TitleMain, SubTitle } from './styles';



const DashboardComponent = () => {

  if (localStorage.getItem('perfiles').includes('Admin')) {
    return (
      <Dashboard>
        <TitleMain>
          Bienvenido
        </TitleMain>

        <div style={{ overflowY: 'auto', height: '700px', width: '1080px' }} >
          <SubTitle>
            Estado de operaciones del día
          </SubTitle>
          <PodContainer>
            <StateProcess />
          </PodContainer>

          <SubTitle>
            Estado de lectura de archivos del facturador
          </SubTitle>
          <PodContainer>
            <DocumentProcess />
          </PodContainer>

          <SubTitle>
            Estado Masivo Etapa 1
          </SubTitle>
          <PodContainer>
            <StateMasiveOne />
          </PodContainer>

          <SubTitle>
            Estado Masivo Etapa 3
          </SubTitle>
          <PodContainer>
            <StateMasiveThree />
          </PodContainer>

          <SubTitle>
            Estado Masivo Estado Pago
          </SubTitle>
          <PodContainer>
            <StateMasiveStatusPay />
          </PodContainer>
        </div>

      </Dashboard>
    );
  } else {
    this.props.history.push('/home/consult/estadoPago');
    return "";
  }
};

export default DashboardComponent;